import { render, staticRenderFns } from "./EditSelfHelp.vue?vue&type=template&id=2075aa52"
import script from "./EditSelfHelp.vue?vue&type=script&lang=js"
export * from "./EditSelfHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports